import React from 'react';
import ContentMap from './ContentMap';
import PageLayout from '../app/layout/PageLayout';
import PageMeta from '../utils/PageMeta';

const AllTopicsView = () => (
  <PageLayout.Content noPaddingX noPaddingY>
    <PageMeta title="Content Map - Slab" />
    <ContentMap />
  </PageLayout.Content>
);

export default AllTopicsView;
